export default { 
  PublicBeranda: require('./PublicBeranda').default,
  Nutrisi: require('./Nutrisi').default,
}